const ROOT = 'requestVideo';

export const requestVideoKeys = {
  units: (search) => [ROOT, 'units', search || ''],
  unitById: (cameraDeviceId) => [ROOT, 'unit', cameraDeviceId],
  days: (activityUnitId, timeZone) => [ROOT, 'days', activityUnitId, timeZone],
  trips: (activityUnitId, dayKey, timeZone) => [ROOT, 'trips', activityUnitId, dayKey, timeZone],
  trail: (activityUnitId, startMs, endMs) => [ROOT, 'trail', activityUnitId, startMs, endMs],
};
